import React from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import { Container } from '@mui/material'
import AppForm from '../form/AppForm'
import AppInput from '../form/AppInput'
import SubmitButton from '../form/SubmitButton'
import Header from '../form/Header'
import { formTypeList } from '../../constants/form'
import {
    addNewProdcutStyle,
    updateProductStyle,
} from '../../store/actions/productStyleAction'

const validationSchema = Yup.object().shape({
    name: Yup.string().required().label('Name'),
})

const Form = ({
    formType,
    setOpen,
    productCategoryId = null,
    propsValue = null,
}) => {
    const dispatch = useDispatch()
    return (
        <Container>
            <Header
                title={`${formType === formTypeList.NEW ? 'ADD' : ''}${
                    formType === formTypeList.EDIT ? 'EDIT' : ''
                } PRODUCT STYLE`}
            />
            <AppForm
                initialValues={{
                    name: propsValue ? propsValue.name : '',
                    description: propsValue ? propsValue.description : '',
                }}
                onSubmit={(values) => {
                    const submitValues =
                        formType === formTypeList.NEW
                            ? { ...values, productCategoryId }
                            : { ...propsValue, ...values }
                    formType === formTypeList.NEW
                        ? dispatch(
                              addNewProdcutStyle(submitValues),
                              setOpen(false)
                          )
                        : dispatch(
                              updateProductStyle(submitValues),
                              setOpen(false)
                          )
                }}
                validationSchema={validationSchema}
            >
                <AppInput
                    name="name"
                    label="Name"
                    type="text"
                    inputProps={{
                        maxLength: 100,
                    }}
                    required={true}
                />
                <AppInput
                    name="description"
                    label="Description"
                    type="text"
                    inputProps={{
                        maxLength: 250,
                    }}
                />
                <SubmitButton title="Submit" />
            </AppForm>
        </Container>
    )
}

export default Form
